import { memo, type PropsWithChildren } from 'react';

type CommentsFilterBarProps = PropsWithChildren<object>;

export const CommentsFilterBar = memo(({ children }: CommentsFilterBarProps) => {
  return (
    <div className="h-8">
      <div className="flex items-center justify-between">{children}</div>
    </div>
  );
});

CommentsFilterBar.displayName = 'CommentsFilterBar';
